import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  RadioButtonGroupInput,
  ReferenceInput,
  SelectInput,
  required,
  minLength,
  email,
  BooleanInput,
  FormDataConsumer,
} from 'react-admin'
import { EmailVerificationInfoAlert } from '../../components/EmailVerificationAlerts';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';
import { getChainId } from '../../lib';
import { validateChainSelected } from '../../lib/formValidators';

const validate = [required()];
const validateEmail = [required(), email()]
const validatePassword = [required(), minLength(6)];

export default props => {
  return (
    <Permission permission={PERMISSIONS.CREATE_USER}>
      <Create {...props} title="Cadastrar novo usuário">
        <SimpleForm sx={{ maxWidth: 600 }} validate={validateChainSelected(getChainId)}>
          <Permission permission={PERMISSIONS.ADMIN}>
            <ReferenceInput {...props} label="Rede" source="chainId" reference="chains" sort={{ field: 'name', order: 'ASC' }} perPage={null} >
              <SelectInput optionText="name" />
            </ReferenceInput>
          </Permission>
          <TextInput source="name" label="Nome" validate={[required()]} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
          <TextInput source="login" label="Login" validate={validateEmail} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
          <TextInput source="password" label="Senha" validate={validatePassword} InputProps={{ autoComplete: 'new-password' }} sx={{ minWidth: 300 }} />
          <Permission permission={PERMISSIONS.EDIT_MAX_POINTS}>
            <NumberInput source="maxPoints" label="Pontos por CPF" validate={validate} InputProps={{ autoComplete: 'off' }} />
          </Permission>
          <FormDataConsumer>
            {({ formData }) => (
              <ReferenceInput
                sx={{ width: 220 }}
                source="profileId"
                reference="profiles"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={9999}
                filter={{ chainId: formData.chainId }}>
                <RadioButtonGroupInput label="Perfil" optionText="name" validate={[required()]} />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <BooleanInput source="mustChangePassword" label="Forçar usuário a trocar senha no primeiro acesso" />
          <EmailVerificationInfoAlert />
        </SimpleForm>
      </Create>
    </Permission>
  )
}